import { CustomThemeOptions } from '../themeTypes';

export default {
  custom: {
    pages: {
      login: {
        hideDirections: true,
      },
    },
  },
  palette: {
    primary: {
      main: '#888',
    },
  },
  props: {
    MuiLink: {
      underline: 'hover',
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: '#08c',
        '&:hover': {
          color: '#006699',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        height: 30,
        backgroundColor: '#fff',
        '&$focused $notchedOutline': {
          borderColor: 'rgba(82, 168, 236, 0.8)',
          boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(82, 168, 236, 0.6)',
        },
        '&:hover $notchedOutline': {
          borderColor: '#ccc',
        },
      },
      notchedOutline: {
        borderColor: '#ccc',
      },
      input: {
        padding: '10px',
      },
    },
    MuiInputLabel: {
      root: {
        marginBottom: 0,
        fontWeight: 400,
      },
    },
    MuiButton: {
      contained: {
        height: 24,
        borderRadius: 0,
        '&:focus': {
          '&::before': {
            display: 'none',
          },
        },
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: '#666',
        },
      },
    },
  },
} as CustomThemeOptions;
